import Layout from '@/views/layout'
export default {
  path: '/userCenter',
  menuName: '用户中心',
  component: Layout,
  redirect: 'noredirect',
  name: 'userCenter',
  meta: { title: 'userCenter', icon: 'user-center', iconType: 'svg' },
  children: [
    {
      path: 'carManagement',
      name: 'carManagement',
      component: () => import('@/views/userCenter/carManagement'),
      menuName: '车辆管理',
      meta: { title: 'carManagement', icon: 'carManagement', iconType: 'svg' }
    },
    {
      path: 'tboxManagement',
      name: 'tboxManagement',
      component: () => import('@/views/userCenter/tboxManagement'),
      menuName: 'T-Box管理',
      meta: { title: 'tboxManagement', icon: 'carManagement', iconType: 'svg' }
    },
    {
      path: 'appUserManagement',
      name: 'appUserManagement',
      menuName: 'APP用户管理',
      component: () => import('@/views/userCenter/appManagement'),
      meta: { title: 'appUserManagement', icon: 'appUserManagement', iconType: 'svg' }
    },
    {
      path: 'feedback',
      name: 'feedback',
      component: () => import('@/views/userCenter/feedback'),
      menuName: '用户反馈',
      meta: { title: 'feedback', icon: 'feedback', iconType: 'svg' }
    },
    
    {
      path: 'smslog',
      name: 'SMSlog',
      component: () => import('@/views/userCenter/SMSlog'),
      menuName: '短信日志',
      meta: { title: 'shop', icon: 'smslog', iconType: 'svg' }
    },
    
    {
      path: 'operLog',
      name: 'UserOperLog',
      component: () => import('@/views/userCenter/userOperLog'),
      menuName: '',
      meta: { title: 'shop', icon: 'log', iconType: 'svg' }
    }
  ]
}